module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_8.f5db20ab.png";